import * as NotificationDropdownActions from './action-creators';

export { NotificationDropdownActions };
import { dropdownReducer } from './reducer';

const notificationDropdownReducer = dropdownReducer;

export { notificationDropdownReducer };


// WEBPACK FOOTER //
// ./src/core/services/notifications/dropdown/index.js